// heic2any loader for browser
import heic2any from "heic2any";

export function isHeicFile(file) {
  if (!file) return false;
  const type = (file.type || "").toLowerCase();
  const name = (file.name || "").toLowerCase();
  return type === "image/heic" || type === "image/heif" || name.endsWith(".heic") || name.endsWith(".heif");
}

export async function convertHeicFileToJpeg(file) {
  if (!isHeicFile(file)) return file;
  try {
    const result = await heic2any({
      blob: file,
      toType: "image/jpeg",
      quality: 0.92,
    });
    const jpgBlob = Array.isArray(result) ? result[0] : result;
    const newName = file.name.replace(/\.(heic|heif)$/i, ".jpg");
    return new File([jpgBlob], newName, { type: "image/jpeg" });
  } catch (err) {
    // If conversion fails, keep the original file
    return file;
  }
}

export async function convertHeicFilesToJpeg(files) {
  const convertedFiles = [];
  for (const file of files) {
    convertedFiles.push(await convertHeicFileToJpeg(file));
  }
  return convertedFiles;
}

// Camera RAW formats (CR2/CR3/NEF/ARW/DNG/...) and TIFF - no browser can
// preview these in an <img> tag, and the server's image library (sharp)
// can't decode true camera RAW either, so they silently end up unusable
// (broken thumbnail, or a raw file copied as-is into the final order).
// Must be rejected at file-selection time, not discovered later. HEIC/HEIF
// are NOT in this list - those are handled separately by conversion above.
const UNSUPPORTED_RAW_EXTENSIONS = [
  '.raw', '.cr2', '.cr3', '.crw', '.nef', '.arw', '.srf',
  '.dng', '.orf', '.raf', '.rw2', '.tiff', '.tif',
];

export function isUnsupportedRawFile(file) {
  if (!file) return false;
  const name = (file.name || '').toLowerCase();
  return UNSUPPORTED_RAW_EXTENSIONS.some(ext => name.endsWith(ext));
}

// Splits files into supported/rejected, alerting the customer about any
// rejected RAW/TIFF camera files so they can re-export as JPG instead of
// discovering a broken photo only after the order is placed.
export function filterOutRawFiles(files) {
  const supported = [];
  const rejected = [];
  for (const file of files) {
    (isUnsupportedRawFile(file) ? rejected : supported).push(file);
  }
  if (rejected.length > 0) {
    alert(
      `${rejected.length} foto (${rejected.map(f => f.name).join(', ')}) janë në format RAW të kamerës (p.sh. CR2, CR3, NEF, DNG) ose TIFF dhe nuk mbështeten.\n\n` +
      `Ju lutem eksportojini/konvertojini këto foto si JPG dhe provoni përsëri.`
    );
  }
  return supported;
}
